// extracted by mini-css-extract-plugin
export var colors = "search_page-module--colors--bbafa";
export var head = "search_page-module--head--d2d07";
export var images = "search_page-module--images--6cfac";
export var img = "search_page-module--img--b2ccb";
export var indicate = "search_page-module--indicate--a795f";
export var mswipe = "search_page-module--mswipe--bdaab";
export var pages = "search_page-module--pages--23c6c";
export var pages_head = "search_page-module--pages_head--cd130";
export var pop_images = "search_page-module--pop_images--6f17b";
export var poptiles = "search_page-module--poptiles--3d60d";
export var prods_head = "search_page-module--prods_head--0ab4c";
export var resultswr = "search_page-module--resultswr--f0562";
export var search_page = "search_page-module--search_page--a272c";
export var t_title = "search_page-module--t_title--09820";
export var tiles = "search_page-module--tiles--e6caa";
export var title = "search_page-module--title--09a2d";